module.exports = __webpack_public_path__ + "static/media/post.87c2b97e.svg";